<template lang="pug">
.v-product-slider.product-slider
	v-loader(:loading="loading")
	v-swiper-slider(v-if="slider && slider.items && slider.items.length"
			:options="options"
			:navigation="navigation")
		swiper-slide.product-slider__slide(v-for="(item, index) in slider.items" :key="index")
			v-product(v-if="slider.type === 'products'" :product="item")
			v-article-poster(v-if="slider.type === 'articles'" :article="item")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import breakpoints from '../scripts/breakpoints.js';
import uniqueId from '../scripts/helpers/uniqueId.js';
import {SwiperSlide} from "swiper/vue";

export default {
	components: {
		SwiperSlide,
	},

	mixins: [
		sourceMixin
	],

	data() {
		return {
			slider: {},
			uniqueId: uniqueId('swiper-'),
			options: {
				slidesPerView: 1,
				spaceBetween: 24,
				a11y: {
					prevSlideMessage: 'Предыдущий слайд',
					nextSlideMessage: 'Следующий слайд',
				},
				breakpoints: {
					[breakpoints['lg-min']]: {
						slidesPerView: 5
					},
					[breakpoints['md-min']]: {
						slidesPerView: 3
					},
					[breakpoints['xs-min']]: {
						slidesPerView: 2
					}
				}
			},
			navigation: true
		};
	},

	methods: {
		dataSet(data) {
			this.slider = data;
		}
	}
};
</script>